import styled from 'styled-components'

import get from 'lodash/get'

import {
  useGetListingReviewsQuery,
  useGetAdventureReviewsQuery,
} from 'hooks/useQueries'
import { fetchMoreFromCollection } from 'utils/api'

import Button from 'components/display/Button'
import DialogModal from '../../display/DialogModal'
import ReviewsList from '../ReviewList'
import ReviewScore from '../ReviewScore'

const Header = styled.div`
  margin-bottom: 33px;
  h3 {
    font-size: 30px;
    margin: 0 0 9px 0;
  }
`

type ReviewsModalProps = {
  reviewType: 'listing' | 'adventure'
  typeId: string
  isOpen: boolean
  onRequestClose(): void
  reviewScore: number | string
}

const ReviewsModal = ({
  reviewType,
  typeId,
  reviewScore,
  isOpen,
  onRequestClose,
}: ReviewsModalProps) => {
  const isListing = reviewType === 'listing'
  const listingResult = useGetListingReviewsQuery({
    variables: { listingId: typeId },
    skip: !isListing,
  })
  const adventureResult = useGetAdventureReviewsQuery({
    variables: { id: typeId },
    skip: isListing,
  })
  const { loading, data, fetchMore } = isListing
    ? listingResult
    : adventureResult
  const reviewsConnection = get(data, `${reviewType}.reviews`)
  const hasNextPage = get(data, `${reviewType}.reviews.pageInfo.hasNextPage`)
  const handleFetchMore = () =>
    fetchMoreFromCollection(data, fetchMore, `${reviewType}.reviews`)

  return (
    <DialogModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      rounded
      narrow
      smallModal
      closeButtonColour="-ds-neutral-700"
    >
      <Header>
        <h3>Reviews</h3>
        <ReviewScore score={reviewScore} size="large" />
      </Header>

      <ReviewsList
        loading={loading}
        reviewsConnection={reviewsConnection}
        condensed
      />

      {hasNextPage && (
        <Button
          onClick={handleFetchMore}
          ghost
          uppercase={false}
          style={{ margin: '30px auto 0 auto' }}
        >
          Show more reviews
        </Button>
      )}
    </DialogModal>
  )
}

export default ReviewsModal
